<div class="info-maintenance-content">
  <figure></figure>
  <div class="info-maintenance-content__body-container">
    <p [translate]="'eos-tv-shop-ii.text.info-planned-maintenance'"
       [translateParams]="{
       startDayName: startDayName,
       startDayHour: startDayHour,
       startDayMinutes: startDayMinutes,
       endDayName: endDayName,
       endDayHour: endDayHour,
       endDayMinutes: endDayMinutes }"></p>
  </div>
</div>

